module.exports = {"cards":[{"title":"Visa","icon":"visa"},{"title":"Discover","icon":"discover"},{"title":"American Express","icon":"americanExpress"},{"title":"MasterCard","icon":"masterCard"}],"title":"Online payment methods","description":"1stdibs accepts the following payment methods:","paypalPriceThreshold":55000}


//////////////////
// WEBPACK FOOTER
// ./assets/js/newPdp/constants/paymentMethodsConstants.json
// module id = 1822
// module chunks = 4 14